// extracted by mini-css-extract-plugin
export var activityContainer = "_kg-0";
export var typingIndicatorContainer = "_kg-1";
export var typingIndicatorDot = "_kg-2";
export var wave = "_kg-3";